/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArchiveStoreInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type archiveStoreMutationVariables = {|
  input: ArchiveStoreInput
|};
export type archiveStoreMutationResponse = {|
  +archiveStore: ?{|
    +store: {|
      +state: ?string
    |}
  |}
|};
export type archiveStoreMutation = {|
  variables: archiveStoreMutationVariables,
  response: archiveStoreMutationResponse,
|};
*/


/*
mutation archiveStoreMutation(
  $input: ArchiveStoreInput!
) {
  archiveStore(input: $input) {
    store {
      state
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ArchiveStoreInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "archiveStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArchiveStorePayload",
        "kind": "LinkedField",
        "name": "archiveStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "archiveStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArchiveStorePayload",
        "kind": "LinkedField",
        "name": "archiveStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "archiveStoreMutation",
    "operationKind": "mutation",
    "text": "mutation archiveStoreMutation(\n  $input: ArchiveStoreInput!\n) {\n  archiveStore(input: $input) {\n    store {\n      state\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9afc6c0ed3f5b9f97d2eee6d9c92cd0d';

module.exports = node;
